import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioTempoRespostaFaixaReducer(state = initialState.relatorioTempoRespostaFaixa, action){
    switch(action.type) {
        case types.RELAT_TEMPO_RESPOSTA_FAIXA:
            
            return action.relatorioTempoRespostaFaixa;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioTempoRespostaFaixaReducer.js
 **/